import { render, staticRenderFns } from "./AppHeaderDesktop.vue?vue&type=template&id=4be106ce&scoped=true&"
import script from "./AppHeaderDesktop.vue?vue&type=script&lang=js&"
export * from "./AppHeaderDesktop.vue?vue&type=script&lang=js&"
import style0 from "./AppHeaderDesktop.vue?vue&type=style&index=0&id=4be106ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be106ce",
  null
  
)

export default component.exports